// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3Awp9","rightAdornment":"Header_rightAdornment__1E5ZO"};